import { defineComponent as _defineComponent } from 'vue'
import { PaginatedQuery, formatHedgingInstrument, OpenPositionsMtmMonitor } from 'ah-api-gateways';
import { defineUseManagedListingProps, useManagedListing, UseManagedListingEmits } from 'ah-common-lib/src/listing';
import { PropType, computed } from 'vue';
import { openPositionsMtmTableFields } from 'ah-trades/src/models/openPositionsMtmTableFields';
import { formatDate } from 'ah-common-lib/src/helpers/time';
import { useTradeState } from '../..';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { capitalize } from 'lodash';
import { formatCurrencyValue } from '../../../../ah-common-lib/src/helpers/currency';

interface OpenPositionsMtmMonitorEmits extends UseManagedListingEmits<OpenPositionsMtmMonitor> {}


export default /*#__PURE__*/_defineComponent({
  __name: 'OpenPositionsMtmListing',
  props: {
  config: {
    type: Object as PropType<{ tableFields: any[] }>,
    default: () => ({ tableFields: openPositionsMtmTableFields }),
  },
  ...defineUseManagedListingProps<OpenPositionsMtmMonitor>(),
},
  setup(__props, { emit }: { emit: ({}), expose: any, slots: any, attrs: any }) {

const props = __props;



const tradeState = useTradeState();



const managedListing = useManagedListing<OpenPositionsMtmMonitor>({
  loadDataRequest(query: PaginatedQuery) {
    return tradeState.services.risk.listOpenPositionsMtm(query);
  },

  emit,
  props,
  fields: computed(() => props.config.tableFields),
  reqManager: useRequestManager().manager,
});

return { __sfc: true,props, tradeState, emit, managedListing, formatHedgingInstrument, formatDate, capitalize, formatCurrencyValue }
}

})